import { AbstractControl } from '@angular/forms'

import { firstValueFrom } from 'rxjs'
import { filter } from 'rxjs/operators'

export async function waitForFormControlValidation(control: AbstractControl): Promise<void> {
  control.updateValueAndValidity()
  if (control.status !== 'PENDING') {
    return
  }
  await firstValueFrom(control.statusChanges.pipe(filter((status) => status !== 'PENDING')), {
    defaultValue: undefined,
  })
}

// valueChanges fires synchronously inside setValue, so a flag scoped to the call marks the
// emission as a framework reconciliation (a Late write), not user input. Subscribers read it in
// a synchronous operator and carry it with the value, so a later debounce cannot lose it.
let lateControlWrite = false

export const isLateControlWrite = (): boolean => lateControlWrite

export function setControlValueLate(control: AbstractControl, value: unknown): void {
  lateControlWrite = true
  try {
    control.setValue(value, { emitEvent: true })
  } finally {
    lateControlWrite = false
  }
}

// A display-only write swaps the stored primitive for its option object and emits, so observers
// such as a cascade child see the resolved option, while the store-write pipeline skips it.
let displayOnlyControlWrite = false

export const isDisplayOnlyControlWrite = (): boolean => displayOnlyControlWrite

export function setControlValueDisplayOnly(control: AbstractControl, value: unknown): void {
  displayOnlyControlWrite = true
  try {
    control.setValue(value, { emitEvent: true })
  } finally {
    displayOnlyControlWrite = false
  }
}
